export default {
  headers: {
    cmms: 'Engie vers GMAO',
    commentary: 'Commentaire',
    contract_addendum: 'Avenant client',
    quotation_status: 'Devis P5',
    contract_equipment: 'Equipement au contrat',
    customer: 'Réalisé par client',
    equipment: 'Equipement',
    existing_equipment: 'Equipement existant',
    planification: 'Engie vers P2P',
    attachment_type: 'Type ratt.',
    property: 'Installation',
    control: 'Contrôle',
    subcontractor: 'Engie vers SST',
    execution_date: 'Date de réalisation',
    max_date: "Date d'échéance",
  },
  filters: {
    title: 'Filtres',
    entity: 'Entité',
    contract: 'Contrats',
    business_id: 'Affaires',
    properties: 'Installations',
    customers: 'Clients',
    regulatory_control_code: 'Contrôles réglementaires',
  },
  icon: 'mdi-clipboard-text',
  title: 'Contrôles Réglementaires',
  params: 'Administration',
  problems: 'Non conformités',
  actions: 'Suivi',
  equipment: {
    icon: 'power',
  },
  property: {
    icon: 'business',
    title: 'Vue par installation',
  },
  control: {
    icon: 'business',
    title: 'Vue par contrôle',
  },
  fields: {
    contract: 'Contrat',
    contractual_equipment: 'Equipement au contrat',
    existing_equipment: 'Equipement existant',
    processed: 'Traitement',
    processedBy: 'Type de traitement',
    contract_addendum: 'Avenant client',
    quotation_status: 'Devis P5',
    frequency: 'Fréquence',
    attachment_type: 'Type de rattachement',
    active: 'Active',
    domain: 'Domaine',
    technicality: 'Intervenant',
    noData: 'Non renseigné',
  },
  noAddendum: "Pas d'avenant",
  noEstimate: 'Pas de devis',
  missingData: 'Veuillez charger toutes les données',
  missingEquipment: "L'équipement n'est pas existant",
  allData: 'Toutes les données sont chargées',
  moreData: 'Il reste des informations à afficher',
  noData: "Pas d'équipement à afficher",
  allControls: 'Ensemble des contrôles',
  allEquipments: 'Ensemble des équipements',

  monitoring: {
    nonCompliance: 'Non Conformité',
    noProblem: 'Conforme & À Réaliser',
    requalification: {
      C: 'Conforme',
      NC: 'Non Conforme',
      noData: '...',
    },
    fields: {
      action: 'Action',
      noAction: "Pas d'action",
      active: 'Active',
      frequency: 'Fréquence',
      control_filter: 'État',
      entity_nav_full_id: 'Entité',
      contract_id: 'Contrat',
      business_id: 'Affaire',
      property_id: 'Installation',
      customer_id: 'Client',
      regulatory_control_code: 'Contrôles réglementaires',
      execution_date: 'Date de réalisation',
      max_date: "Date d'échéance",
    },
    synthesis: {
      title: 'Synthèse périmètre',
      total: 'Total',
      total_non_compliant: 'Total',
      non_compliant: 'Non conforme à traiter',
      non_compliant_in_progress: 'Non conforme en cours',
      realized_compliant: 'Réalisé conforme',
      planned_delayed: 'En retard',
      planned_coming: 'Planifié',
      to_plan: 'À planifier',
    },
  },
  'monitoring/all': {
    fields: {
      action: 'Action',
      noAction: "Pas d'action",
      active: 'Active',
      frequency: 'Fréquence',
      control_filter: 'État',
      entity_nav_full_id: 'Entité',
      contract_id: 'Contrat',
      business_id: 'Affaire',
      property_id: 'Installation',
      customer_id: 'Client',
      regulatory_control_code: 'Contrôles réglementaires',
      execution_date: 'Date de réalisation',
      max_date: "Date d'échéance",
    },
  },
  undo: 'Annuler',
  redo: 'Rétablir',
  save: 'Enregistrer les modifications',
  clearAll: 'Annuler tout',
};
